import 'slick-carousel';

const $recentOrderSlider = $('.js-recent-order-slider');

function getIcon(name) {
  return `
    <svg class='icon icon-${name}' aria-hidden="true">
      <use xlink:href='#icon-${name}'></use>
    </svg>`;
}

function getButton(text, className, icon) {
  return `
    <button type="button" class="${className}">
      <span class="sr-only">${text}</span>
      ${getIcon(icon)}
    </button>
  `;
}

const recentOrderSlider = {
  initialize() {
    if ($recentOrderSlider.length) {
      this.create();
    }
  },

  create() {
    $recentOrderSlider.each((i, slider) => {
      const $slider = $(slider);

      const config = {
        arrows: true,
        slidesToShow: 2.5,
        mobileFirst: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3.5,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2.5,
            },
          },
        ],
        prevArrow: getButton('Vorige', 'slider__arrow slick-prev btn--reset', 'arrow-left'),
        nextArrow: getButton('Volgende', 'slider__arrow slick-next btn--reset', 'arrow-right'),
      };

      $slider.slick(config);
    });
  },
};

export default recentOrderSlider;
